// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color } from "@plumberssupply/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

export interface OrderConfirmationPageTitleStyles {
    headerGridContainer?: GridContainerProps;
    title: TypographyProps;
    titleWrapper: InjectableCss;
}

export const pageTitleStyles: OrderConfirmationPageTitleStyles = {
    titleWrapper: {
        css: css`
            width: 100%;
        `,
    },
    title: {
        color: "common.ui11",
        variant: "h2",
        css: css`
            padding-bottom: 16px;
            border-bottom: 1px solid ${color("common.ui7")};
            @media print {
                margin: 0;
                font-size: 22px;
                padding-bottom: 5px;
            }
        `,
    },
};

type Props = WidgetProps;

const styles = pageTitleStyles;
const OrderConfirmationPageTitle: FC<Props> = () => {
    return (
        <StyledWrapper {...styles.titleWrapper}>
            <Typography {...styles.title}>{siteMessage("OrderConfirmation_Success")}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderConfirmationPageTitle,
    definition: {
        displayName: "Page Title",
        allowedContexts: ["OrderConfirmationPage"],
        group: "Order Confirmation",
    },
};

export default widgetModule;
